import React from 'react';
import Row from './Row/Row';
import VisibilitySensor from 'react-visibility-sensor';
import LeagueName from '../../../shared/Events/Table/Header/LeagueName/LeagueName';

const Table = props => {
    const { events, categoryName, leagueName, leagueId, countryCode } = props;

    return (
        <table className={'common-table'}>
            {events.length > 0 && leagueName ? (
                <thead>
                    <tr>
                        <LeagueName
                            countryCode={countryCode}
                            categoryName={categoryName}
                            leagueName={leagueName}
                            leagueId={leagueId}
                        />
                    </tr>
                </thead>
            ) : null}
            <tbody>
                {events.length > 0
                    ? events.map(event => {
                          return (
                              <VisibilitySensor
                                  key={event.id}
                                  partialVisibility={true}
                                  scrollCheck={true}
                              >
                                  {({ isVisible }) => {
                                      return isVisible ? (
                                          <Row key={event.id} event={event} />
                                      ) : (
                                          <tr key={event.id} style={{ height: '49px' }} />
                                      );
                                  }}
                              </VisibilitySensor>
                          );
                      })
                    : null}
            </tbody>
        </table>
    );
};

export default Table;
